import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import "./SingleStyle.scss";

import Section from "../../components/pages/home/single/section/Section";
import Sidebar from "../../components/general/sidebar/Sidebar";

const Single = () => {
  const { obra } = useParams();

  const [cameraList, setCameraList] = useState([]);
  const [pageTitle, setPageTitle] = useState("Carregando...");
  const [locationInfo, setLocationInfo] = useState("");
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchObraData = async () => {
      setIsLoading(true);
      try {
        const response = await fetch(`/api/obras/${obra}`);

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const obraData = await response.json();

        setPageTitle(obraData.name || obraData.obraName);
        if (obraData.estado && obraData.cidade) {
            setLocationInfo(`${obraData.estado} - ${obraData.cidade}`);
        }

        const camerasWithObraId = obraData.cameras.map((cam) => ({
          ...cam,
          obraId: obra,
        }));
        setCameraList(camerasWithObraId);
      } catch (error) {
        console.error("Erro ao carregar dados da obra via API:", error);
        setPageTitle("Obra não encontrada");
        setCameraList([]);
      } finally {
        setIsLoading(false);
      }
    };

    fetchObraData();
  }, [obra]);

  if (isLoading) {
    return <div>Carregando informações da obra...</div>;
  }

  return (
    <main id="page-single">
      <Section cameras={cameraList} title={pageTitle} location={locationInfo} />
      <Sidebar />
    </main>
  );
};

export default Single;
